<template>
  <div>
    <Company />
    <Supplier />
  </div>
</template>

<script>
import Company from "./CompanyInput";
import Supplier from "./SupplierInput";

export default {
  components: {
    Company,
    Supplier,
  },
};
</script>



// WEBPACK FOOTER //
// src/apps/hemmelig/components/form/parties/PartiesInput.vue